/**
 * 客户端压缩图片，减小上传体积、加快上传速度
 * @param {File} file 原始文件
 * @param {Object} options 压缩参数
 * @returns {Promise<File>}
 */
export function compressImage(file, options = {}) {
  const {
    maxWidth = 1920,
    maxHeight = 1920,
    quality = 0.82,
    skipBelowKB = 200
  } = options

  if (!file || !file.type || !file.type.startsWith('image/')) {
    return Promise.resolve(file)
  }
  if (file.type === 'image/gif' || file.type === 'image/svg+xml') {
    return Promise.resolve(file)
  }
  if (file.size <= skipBelowKB * 1024) {
    return Promise.resolve(file)
  }

  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.onload = () => {
        let w = img.width
        let h = img.height
        if (w > maxWidth || h > maxHeight) {
          const ratio = Math.min(maxWidth / w, maxHeight / h)
          w = Math.round(w * ratio)
          h = Math.round(h * ratio)
        }
        const canvas = document.createElement('canvas')
        canvas.width = w
        canvas.height = h
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, w, h)

        const usePng = file.type === 'image/png'
        const outputType = usePng ? 'image/png' : 'image/jpeg'
        const outputQuality = usePng ? undefined : quality

        canvas.toBlob((blob) => {
          if (!blob || blob.size >= file.size) {
            resolve(file)
            return
          }
          const ext = usePng ? '.png' : '.jpg'
          const baseName = (file.name || 'image').replace(/\.[^.]+$/, '')
          resolve(new File([blob], baseName + ext, {
            type: outputType,
            lastModified: Date.now()
          }))
        }, outputType, outputQuality)
      }
      img.onerror = () => resolve(file)
      img.src = e.target.result
    }
    reader.onerror = () => resolve(file)
    reader.readAsDataURL(file)
  })
}
